export default {
    common: {
        title: 'Contenu IA',
        socialPlanner: 'Planificateur social',
        blog: 'Blog',
        funnel: 'Funnel',
        website: 'Site web',
        email: 'Email',
        words: 'Mots',
        variations: 'Variations',
    },
};
